// import React, { useState, useEffect } from "react";
// import CustomTable from "../../../../customComponents/CustomTable";
// import { useNavigate } from "react-router-dom";
// import axiosInstance from "../../../../services/api/API";
// import ROUTES_NAVIGATION from "../../../../../routes/routes";
// import Loader from "../../../../customComponents/CustomLoader";

// const AcceptedSerialList = ({ selectedItemType, podetaildID }) => {
//   const [actionTaken, setActionTaken] = useState([]);
//   const navigate = useNavigate();
//   const [currentPage, setCurrentPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [totalRecords, setTotalRecords] = useState(0);
//   const token = localStorage.getItem("authToken");
//   const [loading, setLoading] = useState(true);
//   const [filters, setFilters] = useState({});

//   const [totalData, setTotalData] = useState(0);
//   const [totalActive, setTotalActive] = useState(0);
//   const [totalInactive, setTotalInactive] = useState(0);
//   const [filterFormData, setFilterFormData] = useState({});
//   const [validationErrors, setValidationErrors] = useState({});

//   console.log(podetaildID, "podetailsId");
//   console.log(selectedItemType, "selectItemType");

//   // Define the table headers
//   // const TABLE_HEADERS = selectedItemType === 'Vehicle'
//   // ? ['Chassis No', 'VIN No', 'Engine No']
//   // : ['Serial No'];

//   const TABLE_HEADERS = [
//     "VIN No",
//     "Serial No",
//     "Trade Date",
//     "Status",
//     "Dealer Remark",
//     "Admin Remark",
//     "Dealer Acknowledgement Remark",
//   ];

//   // Define key mappings based on the selectedItemType
//   // const keyMapping = selectedItemType === 'Vehicle'
//   // ? {
//   //     'Chassis No': 'chassis_no',
//   //     'VIN No': 'vin_no',
//   //     'Engine No': 'engine_no'
//   // }
//   // : {
//   //     'Serial No': 'serial_no'
//   // };

//   const keyMapping = {
//     "Chassis No": "chassis_no",
//     "VIN No": "vin_no",
//     // 'Engine No': 'engine_no',
//     "Serial No": "serial_no",
//     "Trade Date": "tradedate",
//     Status: "dealer_approved_status_text",
//     "Dealer Remark":"dealer_approval_remark",
//     "Admin Remark":"admin_damaged_missing_remark",
//     "Dealer Acknowledgement Remark":"dealer_final_acknowledge_remark",
//   };
//   // : {

//   // };

//   const handlePageChange = (newPage) => {
//     setCurrentPage(newPage);
//     fetchActionTaken(newPage);
//   };
//   const clearFilter = () => {
//     setFilterFormData({});
//     setFilters({});
//     fetchActionTaken();
//   };
//   const fetchActionTaken = async (page = 0, pageSize = 10) => {
//     // /podetails/getseriallistpoidwise/${podetaildID}
//     try {
//       setLoading(true);
//       const response = await axiosInstance.post(
//         `podetails/getseriallistpoidwise`,
//         {
//           orderBy: "postockinsr_id desc",
//           page,
//           pageSize,
//           endDate: null,
//           startDate: null,
//           po_details_id: podetaildID,
//           searchText: null,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const formattedData = response?.data?.data?.data?.map((item, index) => ({
//         ...item,
//         "Sr No.": index + 1,
//         chassis_no: item.chassis_no || "--",
//         vin_no: item.vin_no || "--",
//         chassis_no: item.chassis_no || "--",
//         serial_no: item.serial_no || "--",
//         dealer_approval_remark: item?.dealer_approval_remark || "--",
//         admin_damaged_missing_remark: item?.admin_damaged_missing_remark || "--",
//         dealer_final_acknowledge_remark: item?.dealer_final_acknowledge_remark || "--"
//       }));

//       const totalRecordsData = response?.data?.data?.totalRecords;

//       const totalCount = response?.data?.data?.total;
//       const totalAct = response?.data?.data?.total_active;
//       const totalInac = response?.data?.data?.total_inactive;

//       setTotalData(totalCount);
//       setTotalActive(totalAct);
//       setTotalInactive(totalInac);

//       setTotalRecords(totalRecordsData);

//       setActionTaken(formattedData);
//       console.log(response, "serialdata");
//       setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
//     } catch (error) {
//       console.error("Error fetching action taken list:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSearch = () => {
//     // Update the filters state with the current form data
//     setFilters({
//       fromDate: filterFormData.startDate || null,
//       toDate: filterFormData.endDate || null,
//       city: filterFormData.city_id || null,
//     });
//   };

//   const handleEditButton = (rowData) => {
//     console.log("rowdata>", rowData);
//     navigate(`${ROUTES_NAVIGATION.ACCEPTORDERDETAILS}`, {
//       state: { data: rowData },
//     });
//     // console.log("rowdata", rowData)
//   };
//   useEffect(() => {
//     if (searchTerm === "") {
//       fetchActionTaken();
//     }
//   }, [searchTerm]);
//   useEffect(() => {
//     setFilterFormData({ ...filterFormData, searchtype: 1 });
//   }, []);
//   const PhysicalStockTakingInputs = [
//     {
//       name: "searchtype",
//       label: "SearchType",
//       placeholder: "Select City",
//       type: "dropdown",
//       options: [
//         { label: "Order Received Request", value: 1 },
//         { label: "Order Accepted", value: 2 },
//       ],
//       required: true,
//       gridClass: "col-lg-2",
//     },
//     {
//       name: "startDate",
//       label: "From Date",
//       type: "date",
//       maxDate: new Date(),
//       required: true,
//       gridClass: "col-lg-2",
//     },
//     {
//       name: "endDate",
//       label: "To Date",
//       type: "date",
//       maxDate: new Date(),
//       required: true,
//       gridClass: "col-lg-2",
//     },
//   ];
//   return (
//     <div>
//       {loading ? (
//         <Loader />
//       ) : (
//         <div>
//           <div className="tableWrapper">
//             {/* <div className='admin-list-container'> */}
//             {/* <div className='listsearchContainer'>
//           <h5>Serial List</h5>

//           </div> */}

//             {/* </div> */}

//             <CustomTable
//               data={actionTaken}
//               headers={TABLE_HEADERS}
//               keyMapping={keyMapping}
//               itemsPerPage={10}
//               currentPage={currentPage}
//               totalPages={totalPages}
//               onPageChange={handlePageChange}
//               handleViewButton={handleEditButton}
//               totalRecords={totalRecords}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AcceptedSerialList;

import React, { useState, useEffect } from "react";
import CustomTable from "../../../../customComponents/CustomTable";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../routes/routes";
import Loader from "../../../../customComponents/CustomLoader";
// import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg';
import editIcon from "../../../../../Assets/icons/Un-Checkbox.svg";
import { showAlert } from "../../../../customComponents/CustomSweetAlert/ShowAlert";
import "./seriallist.scss";

const AcceptedSerialList = ({ selectedItemType, podetaildID, poStatusVal }) => {
  const [actionTaken, setActionTaken] = useState([]);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [editIndex, setEditIndex] = useState(null);
  const [editData, setEditData] = useState({ vin_no: "", serial_no: "" });

  console.log(podetaildID, "podetailsId");
  console.log(selectedItemType, "selectItemType");
  console.log(poStatusVal, "poStatusVal");

  // Define the table headers
  // const TABLE_HEADERS = selectedItemType === 'Vehicle'
  // ? ['Chassis No', 'VIN No', 'Engine No']
  // : ['Serial No'];

  const TABLE_HEADERS = ["VIN No", "Serial No", "Trade Date"];

  // Define key mappings based on the selectedItemType
  // const keyMapping = selectedItemType === 'Vehicle'
  // ? {
  //     'Chassis No': 'chassis_no',
  //     'VIN No': 'vin_no',
  //     'Engine No': 'engine_no'
  // }
  // : {
  //     'Serial No': 'serial_no'
  // };

  const keyMapping = {
    "Chassis No": "chassis_no",
    "VIN No": "vin_no",
    // 'Engine No': 'engine_no',
    "Serial No": "serial_no",
    "Trade Date": "tradedate",
  };
  // : {

  // };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchActionTaken(newPage);
  };
  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchActionTaken();
  };
  const fetchActionTaken = async (page = 0, pageSize = 10) => {
    // /podetails/getseriallistpoidwise/${podetaildID}
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `podetails/getseriallistpoidwise`,
        {
          orderBy: "postockinsr_id desc",
          page,
          pageSize,
          endDate: null,
          startDate: null,
          po_details_id: podetaildID,
          searchText: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        chassis_no: item.chassis_no || "--",
        vin_no: item.vin_no || "--",
        chassis_no: item.chassis_no || "--",
        serial_no: item.serial_no || "--",
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setTotalRecords(totalRecordsData);

      setActionTaken(formattedData);
      console.log(response, "serialdata");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching action taken list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });
  };

  const handleEditButton = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.ACCEPTORDERDETAILS}`, {
      state: { data: rowData },
    });
    // console.log("rowdata", rowData)
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchActionTaken();
    }
  }, [searchTerm]);
  useEffect(() => {
    setFilterFormData({ ...filterFormData, searchtype: 1 });
  }, []);

  const PhysicalStockTakingInputs = [
    {
      name: "searchtype",
      label: "SearchType",
      placeholder: "Select City",
      type: "dropdown",
      options: [
        { label: "Order Received Request", value: 1 },
        { label: "Order Accepted", value: 2 },
      ],
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
  ];

  // const handleEdit = (index, row) => {
  //   setEditIndex(index);

  //   setEditData({
  //     vin_no: row.vin_no && row.vin_no !== "--" ? row.vin_no : "",
  //     serial_no: row.serial_no && row.serial_no !== "--" ? row.serial_no : "",
  //   });
  // };

  // const handleSave = (index) => {
  //   const updated = [...actionTaken];

  //   if (editData.vin_no) updated[index].vin_no = editData.vin_no;
  //   if (editData.serial_no) updated[index].serial_no = editData.serial_no;

  //   setActionTaken(updated);
  //   setEditIndex(null);
  // };

  const handleEdit = (index, row) => {
    setEditIndex(index);
    setEditData({
      vin_no: row.vin_no && row.vin_no !== "--" ? row.vin_no : "",
      serial_no: row.serial_no && row.serial_no !== "--" ? row.serial_no : "",
      charger_no:
        row.charger_no && row.charger_no !== "--" ? row.charger_no : "",
      motor_no: row.motor_no && row.motor_no !== "--" ? row.motor_no : "",
      controller_no:
        row.controller_no && row.controller_no !== "--"
          ? row.controller_no
          : "",
    });
  };

  const handleSave = async (index, row) => {
    console.log(row, "rowDataHAndleSave");
    const updated = [...actionTaken];

    try {
      // Show confirmation dialog before making the API call
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update the record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        return;
      }

      const payload = {
  VinNo:
    editData?.vin_no && editData.vin_no !== "--"
      ? editData.vin_no
      : row?.vin_no && row.vin_no !== "--"
        ? row.vin_no
        : "",

  SerialNo:
    editData?.serial_no && editData.serial_no !== "--"
      ? editData.serial_no
      : row?.serial_no && row.serial_no !== "--"
        ? row.serial_no
        : "",

  ChargerNo:
    editData?.charger_no && editData.charger_no !== "--"
      ? editData.charger_no
      : row?.charger_no && row.charger_no !== "--"
        ? row.charger_no
        : "",

  MotorNo:
    editData?.motor_no && editData.motor_no !== "--"
      ? editData.motor_no
      : row?.motor_no && row.motor_no !== "--"
        ? row.motor_no
        : "",

  ControllerNo:
    editData?.controller_no && editData.controller_no !== "--"
      ? editData.controller_no
      : row?.controller_no && row.controller_no !== "--"
        ? row.controller_no
        : "",

  BatteryNo:
    editData?.battery_no && editData.battery_no !== "--"
      ? editData.battery_no
      : row?.battery_no && row.battery_no !== "--"
        ? row.battery_no
        : "",
};

      // API request to update the color
      const response = await axiosInstance.patch(
        `/podetails/updateStockDetails/${row.postockinsr_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Update successful!", response.data);

      // Show success alert after the update

      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Record updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        fetchActionTaken();
      }

      // Navigate after user clicks OK
      // navigate(ROUTES_NAVIGATION.PRODUCTCOLORLIST);
    } catch (error) {
      console.error("Error updating color:", error);

      // Show error alert in case of failure
      const errorMessage =
        error.response?.data?.message ||
        "Failed to update the record. Please try again.";
      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Hide loading state
    }

    // if (editData.vin_no) updated[index].vin_no = editData.vin_no;
    // if (editData.serial_no) updated[index].serial_no = editData.serial_no;
    // if (editData.charger_no) updated[index].charger_no = editData.charger_no;
    // if (editData.motor_no) updated[index].motor_no = editData.motor_no;
    // if (editData.controller_no)
    //   updated[index].controller_no = editData.controller_no;

    // setActionTaken(updated);
    setEditIndex(null);
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="table-responsive-custom ">
            <table className="table table-bordered table-striped">
              <thead style={{ background: "#f2f2f2" }}>
                <tr>
                  <th>VIN No</th>
                  {/* <th>Charger No.</th> */}
                  <th>Motor No.</th>
                  <th>Controller No.</th>
                  {/* <th>Battery No.</th> */}
                  <th>Serial No</th>
                  <th>Trade Date</th>
                  <th>Status</th>
                  <th>Dealer Remark</th>
                  <th>Admin Remark</th>
                  <th>Dealer Acknowledgement Remark</th>
                  {/* <th>Action</th> */}
                  {poStatusVal !== "Received" && <th>Action</th>}
                </tr>
              </thead>

              <tbody>
                {actionTaken.length > 0 ? (
                  actionTaken.map((row, index) => (
                    <tr key={index}>
                      {/* VIN No */}
                      <td>
                        {editIndex === index &&
                        row.vin_no &&
                        row.vin_no !== "--" ? (
                          <input
                            type="text"
                            value={editData.vin_no}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                vin_no: e.target.value,
                              })
                            }
                            className="form-control"
                          />
                        ) : (
                          row.vin_no || "--"
                        )}
                      </td>

                      {/* Charger No */}
                      {/* <td>
                        {editIndex === index &&
                        row.charger_no &&
                        row.charger_no !== "--" ? (
                          <input
                            type="text"
                            value={editData.charger_no}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                charger_no: e.target.value,
                              })
                            }
                            className="form-control"
                          />
                        ) : (
                          row.charger_no || "--"
                        )}
                      </td> */}

                      {/* Motor No */}
                      <td>
                        {editIndex === index &&
                        row.motor_no &&
                        row.motor_no !== "--" ? (
                          <input
                            type="text"
                            value={editData.motor_no}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                motor_no: e.target.value,
                              })
                            }
                            className="form-control"
                          />
                        ) : (
                          row.motor_no || "--"
                        )}
                      </td>

                      {/* Controller No */}
                      <td>
                        {editIndex === index &&
                        row.controller_no &&
                        row.controller_no !== "--" ? (
                          <input
                            type="text"
                            value={editData.controller_no}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                controller_no: e.target.value,
                              })
                            }
                            className="form-control"
                          />
                        ) : (
                          row.controller_no || "--"
                        )}
                      </td>

                      {/* Battery No (NOT editable) */}
                      {/* <td>{row.battery_no || "--"}</td> */}

                      {/* Serial No */}
                      <td>
                        {editIndex === index &&
                        row.serial_no &&
                        row.serial_no !== "--" ? (
                          <input
                            type="text"
                            value={editData.serial_no}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                serial_no: e.target.value,
                              })
                            }
                            className="form-control"
                          />
                        ) : (
                          row.serial_no || "--"
                        )}
                      </td>

                      {/* Trade Date */}
                      <td>{row.tradedate || "--"}</td> 

                      {/* //     Status: "dealer_approved_status_text", */}
                      {/* //     "Dealer Remark":"dealer_approval_remark", */}
                      {/* //     "Admin Remark":"admin_damaged_missing_remark", */}
                      {/* //     "Dealer Acknowledgement Remark":"dealer_final_acknowledge_remark", */}

                      <td>{row.dealer_approved_status_text || "--"}</td>
                      <td>{row.dealer_approval_remark || "--"}</td>
                      <td>{row.admin_damaged_missing_remark || "--"}</td>
                      <td>{row.dealer_final_acknowledge_remark || "--"}</td>

                      {/* Action Buttons */}
                      {/* <td>
                        {editIndex === index ? (
                          <div className="d-flex gap-2">
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => handleSave(index, row)}
                            >
                              Save
                            </button>
                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() => setEditIndex(null)}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          // <button
                          //   className="btn btn-primary btn-sm"
                          //   onClick={() => handleEdit(index, row)}
                          // >
                          //   Edit
                          // </button>
                          <p onClick={() => handleEdit(index, row)}>
                            <img src={editIcon} alt="editIcon" />
                          </p>
                        )}
                      </td> */}
                      {(poStatusVal === "In Transit" || poStatusVal === "Dispatched") && (
                        <td>
                          {editIndex === index ? (
                            <div className="d-flex gap-2">
                              
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => handleSave(index, row)}
                              >
                                Save
                              </button>
                              <button
                                className="btn btn-secondary btn-sm"
                                onClick={() => setEditIndex(null)}
                              >
                                Cancel
                              </button>
                            </div>
                          ) : (
                            <p onClick={() => handleEdit(index, row)}>
                              <img src={editIcon} alt="editIcon" />
                            </p>
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div>
              <p>
               Showing {currentPage} to {totalPages} of Total {totalRecords} Records
              </p>
              {totalPages > 1 && (
                <div className="d-flex gap-2">
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      onClick={() => handlePageChange(i)}
                      style={{
                        padding: "6px 12px",
                        background: i === currentPage ? "black" : "white",
                        color: i === currentPage ? "white" : "black",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              )}
            </div>
            {/* <div className='admin-list-container'> */}
            {/* <div className='listsearchContainer'>
          <h5>Serial List</h5>
          
          </div> */}

            {/* </div> */}

            {/* <CustomTable
         data={actionTaken} headers={TABLE_HEADERS} keyMapping={keyMapping}   itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          handleViewButton={handleEditButton} 
          totalRecords={totalRecords} 
          /> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default AcceptedSerialList;
